/**
 * Initialises Cookiebot consent renewal links.
 *
 * CMS outputs links with data-href="javascript: Cookiebot.renew()" which
 * browsers block as a security measure. This module intercepts those anchors
 * and calls window.Cookiebot.renew() directly instead, which opens the
 * Cookiebot consent dialog without any unsafe inline script execution.
 */
export function initCookiebotLinks() {
  // Select every anchor whose data-href targets Cookiebot.renew()
  const links = document.querySelectorAll('a[data-href*="Cookiebot.show()"], a[data-href*="Cookiebot.renew()"]');

  links.forEach((link) => {
    // Ensure the element is keyboard-accessible and conveys its role to
    // assistive technologies (the CMS may omit these attributes)
    if (!link.getAttribute('href')) {
      link.setAttribute('href', '#');
    }

    link.addEventListener('click', (event) => {
      event.preventDefault();

      if (typeof window.Cookiebot !== 'undefined' && typeof window.Cookiebot.show === 'function') {
        window.Cookiebot.show();
      } else {
        // Cookiebot has not loaded yet – log a warning in development only
        if (process.env.NODE_ENV !== 'production') {
          console.warn('Cookiebot is not available on window. Make sure the Cookiebot script tag is present.');
        }
      }
    });
  });
}
